import cx from 'classnames'
import { Button, Input } from '@driftt/tide-core-legacy'
import DelayTime from 'components/DelayTime'
import style from './style.styl'

const AutoCloseConfiguration = ({
  timeoutValue,
  timeoutUnit,
  hasUnsavedChanges,
  setTimeoutUnit,
  setTimeoutValue,
  saveChanges,
  discardUnsavedChanged,
  minTimeoutValue,
  maxTimeoutValue,
  exceedsLimitText,
  filters,
  setFilters,
}) => (
  <div className={cx(style.conversationAutoClose, 'content')}>
    <div className="input-group auto-close-filters">
      <Input
        type="checkbox"
        label="Apply only to conversations in which no teammates have ever joined"
        checked={filters.filterTeammateParticipated}
        onChange={(checked) => setFilters({ filterTeammateParticipated: checked })}/>
    </div>
    <div className="auto-close-time">
      <div className="input-group">
        <span>Close conversations after </span>
        <DelayTime
          className="auto-close-timeout"
          value={timeoutValue}
          unit={timeoutUnit}
          validRange={{ min: minTimeoutValue, max: maxTimeoutValue }}
          onUnitChange={setTimeoutUnit}
          onValueChange={setTimeoutValue} />
        <span> of inactivity.</span>
        {_.isInteger(timeoutValue) && (timeoutValue > maxTimeoutValue) &&
          <span className="error-label">{exceedsLimitText}</span>
        }
      </div>
      {hasUnsavedChanges &&
        <div className="save-buttons">
          <Button
            type="primary"
            size="medium"
            onClick={saveChanges}
            disabled={!(
              _.isInteger(timeoutValue) &&
              (timeoutValue >= minTimeoutValue) &&
              (timeoutValue <= maxTimeoutValue)
            )}>
            Save
          </Button>
          <Button type="tertiary" size="medium" onClick={discardUnsavedChanged}>
            Cancel
          </Button>
        </div>
      }
    </div>
  </div>
)

export default AutoCloseConfiguration



// WEBPACK FOOTER //
// ./src/scripts/components/settings/advancedConversationSettings/AutoCloseConfiguration/EditConfiguration/index.js